import React from "react";
import PropTypes from "prop-types";

import classNames from "classnames";

import { IconBuild, IconGem, IconRocket } from "components/Icon";
import LinkButton from "components/LinkButton";

import "./_style.scss";

const linkButtonLook = (type) => {
  if (type === "build") {
    return "secondary-outline";
  }
  if (type === "launch") {
    return "tertiary-outline";
  }
  return "primary-outline";
};

const TimelineStory = ({
  align,
  children,
  date,
  heading,
  href,
  image,
  linkText,
  type,
  ...other
}) => (
  <div
    className={
        classNames({
          "timeline-story": true,
          [`--align-${align}`]: align,
          [`--${type}`]: type,
        })
      }
    {...other}
  >
    <div className="timeline-story__inner">
      <div className="timeline-story__icon">
        {type === "build"
            && <IconBuild />}
        {type === "community"
            && <IconGem />}
        {type === "launch"
            && <IconRocket />}
      </div>
      <div className="timeline-story__date">{date}</div>
      <div className="timeline-story__heading">
        {heading}
        &nbsp;
      </div>
      <div className="timeline-story__content">
        {children}
      </div>
      {href
        && (
        <div className="timeline-story__action">
          <LinkButton href={href} look={linkButtonLook(type)} size="small">{linkText}</LinkButton>
        </div>
        )}
      {image
        && <img className="timeline-story__image" src={image} alt="" />}
    </div>
  </div>
);

TimelineStory.propTypes = {
  align: PropTypes.oneOf(["left", "right"]),
  children: PropTypes.node.isRequired,
  date: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  href: PropTypes.string,
  image: PropTypes.string,
  linkText: PropTypes.string,
  type: PropTypes.oneOf(["launch", "build", "community"]).isRequired,
};

export default TimelineStory;
